class PageQuotes extends HTMLElement {
  constructor() {
    super();

    this.galleryQuotes = this.querySelector(".pagequotes");
    var flkty = new Flickity(this.galleryQuotes, {
      // options
      cellAlign: "left",
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      draggable: false,
    });
  }
}

customElements.define("page-quotes", PageQuotes);
